import { Component, input } from '@angular/core';

import { MediaMovieApiModel } from '@era/inroom-sdk';

@Component({
  selector: 'era-movie',
  templateUrl: './movie.component.html',
  styleUrls: ['./movie.component.scss'],
})
export class MovieComponent {
  readonly movie = input.required<MediaMovieApiModel>();
}
